// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "iframe.report-item-iframe--singleAnswerReportItemIframe--lng6nU0G {\n  border: none;\n  height: 0 !important;\n  width: 100%;\n}\niframe.report-item-iframe--multipleAnswerReportItemIframe--_OqhWCW0 {\n  border: none;\n  margin-top: 0.5em;\n  width: 100%;\n}\niframe.report-item-iframe--hidden--31YSx-aL {\n  display: none;\n}\n", ""]);
// Exports
exports.locals = {
	"singleAnswerReportItemIframe": "report-item-iframe--singleAnswerReportItemIframe--lng6nU0G",
	"multipleAnswerReportItemIframe": "report-item-iframe--multipleAnswerReportItemIframe--_OqhWCW0",
	"hidden": "report-item-iframe--hidden--31YSx-aL"
};
module.exports = exports;
